import type { PaywallCheckoutPreview } from "@circle-react/types";

export const hideWhenItIsFreeTrial = (preview: PaywallCheckoutPreview) => {
  if (preview?.trial_period?.free) {
    return {
      hide: true,
    };
  }

  return {};
};

export const shouldExpandFirstPayment = (preview: PaywallCheckoutPreview) =>
  preview.first_payment.discount < 0 ||
  preview.first_payment.tax > 0 ||
  preview.first_payment.ending_balance < 0;
